var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticStyle:{"margin-top":"10px"},attrs:{"gutter":12}},[_c('el-col',{attrs:{"span":24}},[_c('v-chart',{staticClass:"chart",attrs:{"option":_vm.option}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }